import React, { Component } from 'react';
import { DropTarget, DragSource } from 'react-dnd'
import AddJumpers from './modals/addJumpers'
import CancelJump from './modals/cancelJump'
import RemovableJumper from './modals/removableJumper'
import EditableJumper from './modals/editableJumper'
import EditableFunJumper from './modals/editableFunJumper'

import { Card, CardImg, CardText, CardBody, CardTitle, CardHeader, CardFooter, Row, Col, Button, } from 'reactstrap'
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import loadsStore from '../../stores/loads-store';
import ReactDOM from 'react-dom';
import returnLoadSettings from '../helpers/returnLoadSettings';

var listStyle = { display: 'inline-block', marginRight: '5px', backgroundColor: '#a0c2df', fontSize: '12px', padding: '3px', borderRadius: '5px', marginBottom: '1px' }


const Types = {
    ITEM: 'JUMP'
};

const itemSource = {
    beginDrag(props) {
        //console.log('dragging');
        const item = props
        return item
    },
    endDrag(props, monitor, component) {
        //console.log('endrag')
        if (!monitor.didDrop()) {
            return;
        }
        //return props.handleJumperDrop(props)
        return props;
    }
}

function collect(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging()
    }
}


class RenderCoachJump extends Component {

    constructor() {
        super();
        this.state = {
            optionMenu: false,
            copyOptionSub: false,
            cutOptionSub: false
        }
    }

    toggleOptions = () => {
        this.setState({
            optionMenu: !this.state.optionMenu
        })
    }

    componentWillMount() {
        document.addEventListener('click', this.handleClickOutside, true);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
    }

    handleClickOutside = event => {
        const domNode = ReactDOM.findDOMNode(this);

        if (!domNode || !domNode.contains(event.target)) {
            this.setState({
                optionMenu: false
            });
        }
    }

    handleDelete = (jumpId) => {
        document.getElementById(jumpId).click();
    }

    handleCopyClick = (coach, loadNum, uid) => {
        this.setState({
            copyOptionSub: true
        })
        // console.log('Copyclicked', coach, loadNum);
        var payload = {};
        payload = coach
        payload.coachId = coach.coach["_id"]
        payload.jumperId = coach.jumper["_id"]
        loadsStore.copied = true;
        loadsStore.cut = false;
        loadsStore.copyValue = payload;
        // this.props.toggleToster(true, "copied")
        // var element = document.getElementById(uid);
        // element.style.display = "none";
        if (uid !== -1000) {
            var element = document.getElementById(uid);
            element.style.display = "none";
        }

    }
    handleCutClick = (coach, loadNum, jumpId) => {
        this.setState({
            cutOptionSub: true
        })
        var payload = {};
        payload = coach
        payload.coachId = coach.coach["_id"]
        payload.jumperId = coach.jumper["_id"]
        loadsStore.cut = true;
        loadsStore.cutValue = { loadNum, jumpId }
        loadsStore.copyValue = payload;


    }

    handleCopyPasteClick = (loadNum) => {
        this.setState({
            optionMenu: !this.state.optionMenu,
            optionSub: false,
            copyOptionSub: false,
            cutOptionSub: false
        })
        var Value = loadsStore.copyValue;
        // console.log("pasteclicked", loadNum, Value);
        loadsStore.createCoachJump(loadNum, Value).then(d => {
            // console.log("Coach in pasted", d);
            if (d) {
                if (loadsStore.cut) {
                    loadsStore.cut = false;
                    const { loadNum, jumpId } = loadsStore.cutValue;
                    loadsStore.cancelCoachJump(loadNum, jumpId);
                }
            }
        })

    };

    render() {
        const { coachJump, loadNum, jumpId, coachOptions, isDragging, connectDragSource, src, jumperOptions, isJumperRole, loadsToShow, columnsPerGroup, fontSize } = this.props;
        var IsdisplayOnly = loadsStore.displayOnly ? 'none' : '';
        {
            // console.log("this.props.iscompleted => ", this.props)
        }
        const opacity = isDragging ? 0 : 1;
        const { settingsMoreThan4 } = returnLoadSettings(loadsToShow, columnsPerGroup, fontSize)

        //just
        return connectDragSource(
            <div style={{ opacity }} style={{ pointerEvents: IsdisplayOnly }}>
                {/* {
                    this.state.optionSub &&
                    <ul className="menu-option" style={{ zIndex: '100', position: 'absolute', top: '75px', left: '132px' }}>
                        {
                            this.props.loads.map((load, i) => {
                                if (load.loadNum != loadNum) {
                                    return (<li>
                                        <span onClick={() => this.handleCopyPasteClick(load.loadNum)}>{"Load " + load.loadNum}</span>
                                    </li>)
                                }
                            })
                        }
                    </ul>
                } */}
                {
                    this.state.optionMenu &&
                    <ul className="menu-option">
                        {
                            // console.log("this.props.iscompleted => ", this.props.isCompleted)
                        }
                        {
                            !this.props.isCompleted &&
                            <li>
                                <span style={{ color: 'red' }} onClick={() => this.handleDelete("delete-jump" + jumpId)}>Delete</span>
                            </li>
                        }
                        <li style={{ position: "relative" }} onMouseLeave={() => { setTimeout(() => { this.setState({ copyOptionSub: false }) }, 500) }}>
                            <span onClick={() => this.handleCopyClick(coachJump, loadNum, -1000)} onMouseOver={() => { setTimeout(() => { this.handleCopyClick(coachJump, loadNum, -1000) }, 500) }}>Copy</span>
                            {
                                this.state.copyOptionSub &&
                                <ul className="menu-option" style={{ zIndex: '100', position: 'absolute', top: '0px', right: '167px' }} onMouseLeave={() => { setTimeout(() => { this.setState({ copyOptionSub: false }) }, 500) }}>
                                    {
                                        this.props.loads.map((load, i) => {
                                            if (load.loadNum != loadNum) {
                                                return (<li>
                                                    <span onClick={() => this.handleCopyPasteClick(load.loadNum)}>{"Load " + load.loadNum}</span>
                                                </li>)
                                            }
                                        })
                                    }
                                </ul>
                            }
                        </li>
                        {!this.props.isCompleted && <li style={{ position: "relative" }} onMouseLeave={() => { setTimeout(() => { this.setState({ cutOptionSub: false }) }, 500) }}>
                            <span style={{ color: 'red' }} onClick={() => this.handleCutClick(coachJump, loadNum, jumpId)} onMouseOver={() => { setTimeout(() => { this.handleCutClick(coachJump, loadNum, jumpId) }, 500) }}>Move</span>
                            {
                                this.state.cutOptionSub &&
                                <ul className="menu-option" style={{ zIndex: '100', position: 'absolute', top: '0px', right: '167px' }} onMouseLeave={() => { setTimeout(() => { this.setState({ cutOptionSub: false }) }, 500) }}>
                                    {
                                        this.props.loads.map((load, i) => {
                                            if (load.loadNum != loadNum) {
                                                return (<li>
                                                    <span onClick={() => this.handleCopyPasteClick(load.loadNum)}>{"Load " + load.loadNum}</span>
                                                </li>)
                                            }
                                        })
                                    }
                                </ul>
                            }
                        </li>}
                        {
                            this.props.isCompleted &&
                            <li
                                style={{ pointerEvents: 'initial' }}
                                onClick={() => {
                                    localStorage.setItem("mediaInfo", JSON.stringify({
                                        isCompleted: this.props.isCompleted ? true : false,
                                        loadNum: this.props.loadId || loadNum || "",
                                        jumpId: jumpId || "",
                                        albumId: this.props.coachJump.albumId || "",
                                        name: coachJump.jumper.firstname + coachJump.jumper.lastname,
                                        studentId: coachJump.jumper._id,
                                        albumUrl: this.props.coachJump.albumUrl || '',
                                        jump: coachJump,
                                        type: "coachJump"
                                    }))
                                    window.location.pathname = '/upload_media'
                                }
                                }>
                                <span >Upload</span>
                            </li>
                        }
                        {
                            this.props.isCompleted && this.props.coachJump.albumUrl &&
                            <li
                                style={{ pointerEvents: 'initial' }}
                                onClick={() => {
                                    var win = window.open(this.props.coachJump.albumUrl, '_blank');
                                    win.focus();
                                }}>
                                <span >View Media</span>
                            </li>
                        }
                    </ul>
                }
                <Card className="jumpcard" style={{ pointerEvents: IsdisplayOnly }} >
                    {/* <CardHeader className="jumpcardheader align-items-center row">
                        <div className="col-10">
                            Coach Jump
	    		        </div>
                        <div className="col-2">
                            <CancelJump loadNum={loadNum} jumpId={jumpId} jumpType={"coachJump"} />
                        </div>
                    </CardHeader> */}
                    {!this.props.isCompleted && <CancelJump loadNum={loadNum} jumpId={jumpId} jumpType={"coachJump"} />}
                    <CardBody className="custom-card-body" style={{ padding: '3px' }}>
                        {/* <ul className="list-unstyled">
                        	<li style={listStyle}>
                        		<EditableJumper type={"coach"} label={"Coach"} loadNum={loadNum} jumpId={jumpId} jumper={coachJump.coach} options={coachOptions} />
                        	</li>
                        	<li style={listStyle}>
                    			<EditableFunJumper type={"coach"} label={"Jumper"} loadNum={loadNum} jumpId={jumpId} jumper={coachJump.jumper} options={jumperOptions} />
                    		</li>
                        </ul> */}
                        <Row>
                            <div className={settingsMoreThan4 ? "funjumptype custom-col" : "funjumptype col-3"} style={{ backgroundColor: '#E8EEFF' }}>
                                <strong>{coachJump.isWingsuit !== undefined && coachJump.isWingsuit ? 'Wingsuit Coach' : 'Coach'}</strong>

                            </div>

                            <div className={settingsMoreThan4 ? "cardmiddle jumpers-container" : "cardmiddle col-9"}>
                                <ul className="coach-load">
                                    <li>
                                        <EditableJumper activeJumperIdsOnLoad={this.props.load.activeJumperIds} type={"coach"} label={"C"} loadNum={loadNum} jumpId={jumpId} jumper={coachJump.coach} options={coachOptions} />
                                    </li>

                                    <li>
                                        <EditableFunJumper activeJumperIdsOnLoad={this.props.load.activeJumperIds} type={"coach"} label={"J"} loadNum={loadNum} jumpId={jumpId} jumper={coachJump.jumper} options={jumperOptions} />
                                    </li>
                                </ul>

                                {loadsStore.displayOnly ? null :
                                    <div className="right-menu" style={{ pointerEvents: 'initial' }} onClick={this.toggleOptions} onBlur={this.toggleOptions}>
                                        <span>
                                            <i class="fa fa-ellipsis-v"></i>
                                        </span>
                                    </div>
                                }
                            </div>
                            {/*
                            <Col xs="12" md="2" lg="1" className="jumpClose">
                                <CancelJump loadNum={loadNum} jumpId={jumpId} jumpType={"coachJump"} />
                            </Col> */}
                        </Row>
                    </CardBody>
                    {coachJump.note && window.ENV.tenant === "montereybay" ?
                        <CardFooter className="fun-card-footer" >{coachJump.note}</CardFooter> : null}
                </Card>
            </div>
        )
    }
}


export default DragSource(Types.ITEM, itemSource, collect)(RenderCoachJump)
